import React from 'react';
import { IndexCtaMainDiv } from '../../styles/download';
import { Button } from '../../styles/reusable';


const IndexCtaSection = () => {


    return (

        <IndexCtaMainDiv>
            <div className='container'>
                <div className='header'>
                    <h3 >
                        Start Building with agent in minutes
                    </h3>
                </div>

                <div className='button'>

                    <Button
                        className='button'
                        bg='white'
                        color='black'
                        hoverColor='white'
                        hoverBg='transparent'
                        border='1px solid white'
                        onClick={() => window.location.href = "https://app.trysixth.com"}
                    >
                        Get started
                    </Button>
                </div>

            </div>



        </IndexCtaMainDiv>

    )
}

export default IndexCtaSection;